import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useLocationsTableColumns = (
  goToInfoPage,
  deleteItem,
  editItem,
  apiRef,
  columnPermissions = {},
) => {
  const {
    canDetail = false,
    canEdit = false,
    canDelete = false,
  } = columnPermissions;

  const canViewActions = canDetail || canEdit || canDelete;

  const columnsData = [
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.title;
      },
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 240,

            getActions: params => {
              const buttons = [
                canDetail
                  ? {
                      label: 'جزئیات',
                      Icon: InfoIcon,
                      onClick: goToInfoPage(params.row),
                      color: 'primary',
                    }
                  : null,
                canEdit
                  ? {
                      label: 'ویرایش',
                      Icon: ModeEditOutlineIcon,
                      onClick: editItem(params.row),
                      color: 'info',
                    }
                  : null,
              ].filter(Boolean);

              return [
                buttons.length ? (
                  <TableActionButtons key={10} buttons={buttons} />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={2}
                    icon={<DeleteIcon />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useLocationsTableColumns;
